import { FullContainer } from '@gorila-shared-ui/components';
import { AsideLayout } from '../../layout/AsideLayout';
import SubAccountsProvider from '../../providers/SubAccountsProvider';
import { SubAccountDetail } from './SubAccountDetail';
import { SubAccountList } from './SubAccountList';

export function SubAccountTab() {
  return (
    <FullContainer flexible>
      <SubAccountsProvider />
      <AsideLayout aside={<SubAccountList />}>
        <SubAccountDetail />
      </AsideLayout>
    </FullContainer>
  );
}
